import { Stack } from "@mui/material";
import SeasonChart from "./partials/SeasonChart";
import useQueryState from "../../../../hooks/useQueryState";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ClimatesChart from "./partials/ClimatesChart";
import { CLIMATE_LAYERS } from "../../../../enums/layers";

const DroughtRisk = () => {
  const { setQueryState } = useQueryState()
  const { search } = useLocation();

  useEffect(() => {
    if(!search) {
      setQueryState({
        // season: '1',
        climate: CLIMATE_LAYERS[0]?.displayName
      })
    }
  }, [search, setQueryState])

  return (
    <Stack bgcolor="#FAFAFA" flex={1} p={2} gap={2} overflow="hidden" minWidth={0} minHeight={0}>
      <ClimatesChart />
      <SeasonChart />
    </Stack>
  );
};

export default DroughtRisk;
